export default __webpack_public_path__ + "static/media/step-4.7c08a20f.svg";